import React from "react";
import { CircularProgress, Backdrop, Box, Typography } from "@mui/material";

const LoadingIndicator: React.FC<{ open: boolean }> = ({ open }) => {
    return (
        <Backdrop open={open} sx={{ color: "#fff", zIndex: 2000 }}>
            <Box display="flex" flexDirection="column" alignItems="center">
                <CircularProgress color="inherit" />
                <Typography variant="subtitle1" sx={{ marginTop: 2 }}>กำลังโหลด...</Typography>
            </Box>
        </Backdrop>
    );
};

export default LoadingIndicator;